import { GOAL_LEAD_GENERATION, GOAL_LOCAL_OFFERS } from '@/util/constants';

// base field values
const baseFields = {
  message: 500, // max characters
  name: 60, // max characters
  description: 80, // max characters
  caption: 70, // max characters
  // caption should be accessable url (TODO: verify this)
  media_size: 200 * 1024, // kilobytes
  media_count_min: 1, // items
  media_count_max: 1, // items
  call_to_action: [], // one of
  media_formats: ['jpeg', 'jpg', 'png', 'gif', 'mp4', 'mov', 'qt', 'avi', 'txt', 'csv', 'xls', 'xlsx'],
};

const overwriteShort = {
  message: 150, // max characters
  name: 30, // max characters
  description: 40, // max characters
  caption: 35, // max characters
};

const overwriteType = {
  image: {
    media_formats: ['jpeg', 'jpg', 'png'], // one of
  },
  carousel: {
    media_formats: ['jpeg', 'jpg', 'png', 'gif', 'mp4', 'mov', 'qt', 'avi'], // one of
    media_count_min: 3, // items
    media_count_max: 10, // items
    media_field_link: true, // should be accessible URL
    media_field_name: 35, // max characters
    media_field_description: 40, // max characters
    name: undefined, // disable field
    description: undefined, // disable field
    caption: undefined, // disable field
  },
  slideshow: {
    media_formats: ['jpeg', 'jpg', 'png'], // one of
    transition_ms: 100, // min integer
    duration_ms: 100, // min integer
    media_count_min: 3, // items
    media_count_max: 7, // items
  },
  video: {
    media_formats: ['mp4', 'mov', 'qt', 'avi', 'gif'],
    media_size: 200 * 1024, // kilobytes
  },
  external: {
    media_count_max: 50,
    media_size: 200 * 1024, // kilobytes
  },
};

const overwriteTypeShort = {
  image: {},
  carousel: {
    media_field_description: 30, // max characters
  },
  slideshow: {},
  video: {},
};

// goal type specific field values
const goalTypeSpecificFields = {
  [GOAL_LEAD_GENERATION]: {
    privacy_policy_link: 500, // max characters
    default_question: 100, // max characters
    lead_media_formats: ['jpeg', 'jpg', 'png', 'gif'], // one of
    call_to_action: [], // one of
  },
  [GOAL_LOCAL_OFFERS]: {
    name: undefined, // disable field
    description: undefined, // disable field
    caption: undefined, // disable field
    offer_title: 50,
    offer_details: 250,
    offer_code: 20,
    end_date_time: true,
    code_type: ['none', 'one', 'unique'],
    redeem: ['store', 'online', 'both'],
    t_c: 5000,
  },
};

function getGoalTypeFields(goalType, creativeType) {
  const fields = goalTypeSpecificFields[goalType];
  if (goalType === GOAL_LOCAL_OFFERS && creativeType === 'carousel') {
    fields.media_field_description = undefined;
  }
  return goalTypeSpecificFields[goalType];
}

export default (
  creativeType,
  shortLimits = false,
  goalType = false,
  overwrite = {},
) => Object.assign(
  {},
  baseFields,
  shortLimits ? overwriteShort : {},
  overwriteType[creativeType],
  shortLimits ? overwriteTypeShort[creativeType] : {},
  goalType ? getGoalTypeFields(goalType, creativeType) : {},
  overwrite,
);



// WEBPACK FOOTER //
// ./src/util/creativeFields.js